import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Clock, Layers, ArrowRight } from 'lucide-react';
import { AUDIENCE_LABELS } from '../../data/resourceLibrary.js';
import { professionalDevelopmentLessonPath } from '../../constants/professionalDevelopment.js';
import ResourcePrice from './ResourcePrice.jsx';

function ResourceCard({ resource }) {
  return (
    <article className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden border border-slate-100 flex flex-col h-full">
      <div className="bg-gradient-to-br from-emerald-700 to-[#1a4a1a] px-6 py-8 text-white">
        <div className="flex flex-wrap gap-2 mb-4">
          {resource.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-xs font-medium px-2.5 py-1 rounded-full bg-white/15 backdrop-blur-sm"
            >
              {tag}
            </span>
          ))}
        </div>
        <h2 className="text-xl md:text-2xl font-bold leading-tight mb-2">{resource.title}</h2>
        <p className="text-emerald-100 text-sm md:text-base">{resource.subtitle}</p>
      </div>

      <div className="p-6 flex flex-col flex-1">
        <p className="text-slate-600 text-sm md:text-base leading-relaxed mb-6 flex-1">
          {resource.description}
        </p>

        <div className="flex flex-wrap gap-4 text-sm text-slate-500 mb-6">
          <span className="flex items-center gap-1.5">
            <Layers className="w-4 h-4 text-emerald-600" />
            {resource.modulesCount > 0
              ? `${resource.modulesCount} modules`
              : resource.pptxKey || resource.viewUrl
                ? 'Presentation'
                : 'Package'}
          </span>
          <span className="flex items-center gap-1.5">
            <Clock className="w-4 h-4 text-emerald-600" />
            {resource.duration}
          </span>
          <span className="flex items-center gap-1.5">
            <BookOpen className="w-4 h-4 text-emerald-600" />
            {AUDIENCE_LABELS[resource.audience] || resource.audience}
          </span>
        </div>

        <div className="flex items-center justify-between gap-4 pt-4 border-t border-slate-100">
          <ResourcePrice resource={resource} />
          <Link
            to={professionalDevelopmentLessonPath(resource.slug)}
            className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-5 py-2.5 rounded-xl transition-colors text-sm shrink-0"
          >
            Open package
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </article>
  );
}

export default ResourceCard;
